import React from 'react';
import { useLocation } from 'react-router';
import {
  Col, Container, Row,
} from 'react-bootstrap';

import Tag from 'components/DesignSystem/Tag';
import Icon from 'components/DesignSystem/Icon';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import BodyRegular from 'components/Typography/BodyRegular';
import { PermissionTypes, permissionProductMap } from 'helper/products';
import { getAccessContent } from 'helper/accessRequestContent';

import RequestAccessActions from './RequestAccessActions';
import './index.scss';

export default function NoAccessPage() {
  const { search } = useLocation();
  const permission = new URLSearchParams(search).get('product') as PermissionTypes | null;

  if (!permission) {
    return (
      <Container className="no-access">
        <h1 className="title-bold">Oops!</h1>
        <SubtitleRegular>Você não tem acesso a esta página.</SubtitleRegular>
      </Container>
    );
  }

  const produto = permissionProductMap[permission] ?? permission;
  const content = getAccessContent(produto);

  return (
    <Container className="no-access">
      <div className="no-access__wrapper">
        <div className="no-access__hero">
          {content.iconeProduto && (
            <div className="no-access__product-icon" aria-hidden="true">
              <Icon iconType={content.iconeProduto} size="large" />
            </div>
          )}
          <Tag type="primary" icon="locked">Produto não incluído no seu plano</Tag>
          <h1 className="title-bold no-access__title">{content.titulo}</h1>
          <SubtitleRegular>{content.subtitulo}</SubtitleRegular>
        </div>

        {content.cards.length > 0 && (
          <Row className="no-access__cards g-3">
            {content.cards.map((card) => (
              <Col md={4} key={card.titulo}>
                <div className="no-access__card">
                  <span aria-hidden="true" className="no-access__card-icon">
                    <Icon iconType={card.icone} size="regular" />
                  </span>
                  <h2 className="subtitle-semi-bold no-access__card-title">{card.titulo}</h2>
                  <BodyRegular>{card.descricao}</BodyRegular>
                </div>
              </Col>
            ))}
          </Row>
        )}

        <hr className="no-access__divisor" />
        <RequestAccessActions produto={permission} />
      </div>
    </Container>
  );
}
